import { render, staticRenderFns } from "./PlatformLogo.vue?vue&type=template&id=a8807670&scoped=true"
import script from "./PlatformLogo.vue?vue&type=script&lang=js"
export * from "./PlatformLogo.vue?vue&type=script&lang=js"
import style0 from "./PlatformLogo.vue?vue&type=style&index=0&id=a8807670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8807670",
  null
  
)

export default component.exports